import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Password policy (#943): at least 15 characters and nothing else. NIST SP
 * 800-63B-4 forbids composition rules (required upper case, digits,
 * symbols); length is what makes a password strong. The API mirrors this in
 * `api/src/utils/validators.ts`.
 */
export const MIN_PASSWORD_LENGTH = 15;

/** The one-line hint shown under every new-password field. */
export const PASSWORD_LENGTH_HINT =
  'At least 15 characters. A few words strung together work well.';

export class PasswordValidators {
  constructor() {}

  static patternValidator(regex: RegExp, error: ValidationErrors): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (!control.value) {
        // if the control value is empty return no error.
        return null;
      }

      // test the value of the control against the regexp supplied.
      const valid = regex.test(control.value);

      // if true, return no error, otherwise return the error object passed in the second parameter.
      return valid ? null : error;
    };
  }
}
